// @flow

export const autoCompleteEnum = {
  off: "chrome-off",
  email: "email"
};

export type autoCompleteType = $Values<typeof autoCompleteEnum>;
